export default __webpack_public_path__ + "static/media/aws-logo-on-dark.a1c539eb.svg";